import React from 'react';
import classnames from 'classnames';
import Icon from '../icon/index';
class Radio extends React.Component {
    constructor() {
        super(...arguments);
        this.handleChange = (e) => {
            const { onChange, disabled } = this.props;
            if (disabled)
                return;
            onChange && onChange(e);
        };
    }
    render() {
        const { children, disabled, size, name, value, checked, className } = this.props;
        const wrapCls = classnames('cfm_radio_wrapper', {
            'cfm_radio_disabled': disabled,
        }, className);
        const checkCls = classnames('cfm_radio', `cfm_radio_${size}`, {
            'cfm_radio_checked': checked,
        });
        return (<label className={wrapCls}>
        <span className={checkCls}>
          <input type='radio' checked={checked} name={name} value={value} onChange={this.handleChange} disabled={disabled} className='cfm_radio_input'/>
          <Icon className='cfm_radio_icon' size={size} type={checked ? 'radio_check' : 'radio_uncheck'}/>
        </span>{children}
      </label>);
    }
}
Radio.defaultProps = {
    checked: false,
    disabled: false,
    size: 'md',
};
export default Radio;



// WEBPACK FOOTER //
// ./components/radio/index.tsx